import React from 'react';
import { FN116 } from '../../../services/pwn201Api';

interface Props {
  totalCount: number;
  rows: FN116[];
  isEditing: boolean;
  onAdd: () => void;
  onDelete: (idx: number) => void;
  onChange: (idx: number, field: keyof FN116, value: unknown) => void;
}

const TabMessages: React.FC<Props> = React.memo(({ totalCount, rows, isEditing, onAdd, onDelete, onChange }) => (
  <div className="pwn201-tab-content">
    <div style={{ marginBottom: 12 }}>
      <span>人數: <strong>{totalCount}</strong></span>
    </div>
    {isEditing && (
      <div className="pwn201-tab-toolbar">
        <button onClick={onAdd} className="btn-add">+ 新增留言</button>
      </div>
    )}
    <table className="pwn201-grid">
      <thead>
        <tr>
          <th>序號</th>
          <th>員工代號</th>
          <th>員工姓名</th>
          <th>傳送人</th>
          <th>留言內容</th>
          <th>傳送日期</th>
          {isEditing && <th>操作</th>}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, idx) => (
          <tr key={idx}>
            <td>{row.fn116_02}</td>
            <td>
              <input
                value={row.fn116_11}
                onChange={(e) => onChange(idx, 'fn116_11', e.target.value)}
                disabled={!isEditing}
                maxLength={8}
              />
            </td>
            <td>
              <input
                value={row.fn116_11a}
                onChange={(e) => onChange(idx, 'fn116_11a', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <input
                value={row.fn116_13}
                onChange={(e) => onChange(idx, 'fn116_13', e.target.value)}
                disabled={!isEditing}
              />
            </td>
            <td>
              <textarea
                value={row.fn116_03}
                onChange={(e) => onChange(idx, 'fn116_03', e.target.value)}
                disabled={!isEditing}
                rows={2}
              />
            </td>
            <td>{row.fn116_12 ? row.fn116_12.substring(0, 10) : ''}</td>
            {isEditing && (
              <td>
                <button onClick={() => onDelete(idx)} className="btn-delete">刪除</button>
              </td>
            )}
          </tr>
        ))}
        {rows.length === 0 && (
          <tr><td colSpan={isEditing ? 7 : 6} style={{ textAlign: 'center', color: '#999' }}>無資料</td></tr>
        )}
      </tbody>
    </table>
  </div>
));

export default TabMessages;
